export const theme = {
    // token: {
    //     borderRadius          : 4,
    //     colorBgBase           : '#f7f7fa',
    //     colorBgContainer      : '#fff',
    //     colorBtnInterface     : '#e4e4e6',
    //     colorBtnInterfaceHover: '#d9d9dc',
    //     colorError            : '#f96666',
    //     colorInfo             : '#6c11c9',
    //     colorPrimary          : '#9a41fe',
    //     colorSuccess          : '#067b00',
    //     colorSuccessBg        : '#f1ffed',
    //     colorSuccessBgHover   : '#def1dd',
    //     colorTextLabel        : '#4e4e53',
    //     colorTextSecondary    : '#4a4a59',
    //     colorTextTertiary     : '#00000073',
    //     colorWarning          : '#ff773c',
    fontFamily: 'WB Hauss VF',
    //     fontSize              : 14,
    //     headerBg              : '#fff',
    //     headerBorderColor     : '#d1cfd7',
    //     headerHeight          : 60,
    //     sizeStep              : 4,
    //     sizeUnit              : 4,
    //     wireframe             : false,
    //     menuSubBg             : '#660ec8',
    //     menuSubShadow         : '#4f139280',
    //     menuSubBorder         : '#4c1689',
    //     menuSubSelected       : '#ecdaff'
    // },
    components: {
        // Breadcrumb: {
        //     fontSize       : 16,
        //     itemColor      : '#00000088',
        //     linkColor      : '#00000088',
        //     linkHoverColor : '#000',
        //     separatorColor : '#00000088',
        //     separatorMargin: 4
        // },
        // Button: {
        //     borderRadiusLG: 8,
        //     fontSize      : 16
        // },
        // Card: {
        //     borderRadiusLG: 12,
        //     padding       : 0
        // },
        // Checkbox: {
        //     borderRadiusSM        : 6,
        //     controlInteractiveSize: 18,
        //     lineWidth             : 2
        // },
        // DatePicker: {
        //     controlHeight: 40
        // },
        // List: {
        //     footerBg     : '#f7f7fa',
        //     headerBg     : '#f7f7fa',
        //     itemPaddingLG: '24px 16px'
        // },
        // Menu: {
        //     activeBarBorderWidth       : 0,
        //     activeBarHeight            : 0,
        //     colorPrimaryBorder         : '#fff',
        //     controlItemBgActive        : '#3a007814',
        //     horizontalItemBorderRadius : 8,
        //     horizontalItemMargin       : 24,
        //     horizontalItemPadding      : 10,
        //     horizontalItemSelectedBg   : '#3a007814', // text-brand-1
        //     horizontalItemSelectedColor: '#3a0078', // text-brand-1
        //     itemHoverBg                : '#3a007814',
        //     darkItemBg                 : 'transparent',
        //     darkItemColor              : '#cc9eff',
        //     darkItemHoverColor         : '#fff',
        //     darkItemHoverBg            : '#731bd5',
        //     darkItemSelectedBg         : '#4c0097',
        //     darkGroupTitleColor        : '#cc9eff',
        //     itemHeight                 : 36,
        //     itemBorderRadius           : 8
        // },
        // Modal: {
        //     borderRadiusLG            : 8,
        //     borderRadiusSM            : 4,
        //     contentBg                 : '#fff',
        //     fontSize                  : 16,
        //     fontSizeHeading5          : 30,
        //     footerBg                  : '#fff',
        //     headerBg                  : '#fff',
        //     margin                    : 16,
        //     marginLG                  : 24,
        //     marginSM                  : 24,
        //     marginXS                  : 24,
        //     padding                   : 20,
        //     paddingContentHorizontalLG: 48,
        //     paddingLG                 : 48,
        //     paddingMD                 : 32,
        //     paddingXS                 : 8
        // },
        // Popover: {
        //     borderRadiusLG: 12,
        //     padding       : 0,
        //     paddingSM     : 0
        // },
        Select: {
            colorPrimary            : 'var(--color-border-basic)',
            colorPrimaryHover       : 'var(--color-border-basic)',
            colorBgElevated         : 'var(--color-white)',
            colorItemTextHover      : 'var(--color-white)',
            colorItemTextSelected   : 'var(--color-text-brand)',
            colorBgContainerDisabled: 'var(--color-icon-disabled-new)',
            colorTextDisabled       : 'var(--color-icon-disabled-new-text)',
            optionSelectedFontWeight: 400,
            controlHeight           : 44,
            controlOutline          : 'none',
            fontSize                : 16,
            optionFontSize          : 16,
            borderRadius            : 4,
            optionSelectedBg        : 'transparent',
            optionSelectedColor     : 'var(--color-text-warning)',
            colorTextPlaceholder    : 'var(--color-grey-700)',
            fontFamily              : 'WB Hauss VF'
        }
        // Table: {
        //     borderColor     : '#ddd',
        //     borderRadiusLG  : 12,
        //     fontWeightStrong: 500,
        //     footerBg        : '#fff',
        //     headerBg        : '#fff',
        //     headerSplitColor: 'transparent'
        // },
        // Tag: {
        //     borderRadiusSM: 4,
        //     lineHeight    : 2,
        //     lineHeightSM  : 2,
        //     lineWidth     : 0
        // },
        // Tree: {
        //     colorBgContainer: '#f7f7fa',
        //     marginXS        : 37,
        //     paddingXS       : 8
        // },
        // Typography: {
        //     colorTextDescription: '#4a4a59',
        //     fontWeightStrong    : 500,
        //     marginXS            : 0,
        //     marginXXS           : 0,
        //     paddingSM           : 0,
        //     titleMarginBottom   : 0,
        //     titleMarginTop      : 0
        // },
        // Layout: {
        //     siderBg: '#660ec8'
        // }
    }
};
